var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8h4.323c.409 0 .777.25.928.63l1.606 4.013c.094.236.143.488.143.742v5.948a1 1 0 01-1 1h-1.831M16 20.42H8.17M22 15h-4v-4h3.2m-8.644-5H14a1 1 0 011 1v9H2m3 4.416H3a1 1 0 01-1-1V7a1 1 0 011-1h1.238M10 6H8V4.16m-.261-2.11c-1.751.268-3.183 1.7-3.451 3.451a4.164 4.164 0 004.766 4.766c1.751-.268 3.183-1.7 3.451-3.45A4.164 4.164 0 007.739 2.05zm10.965 17.246a1.584 1.584 0 11-2.24 2.24 1.584 1.584 0 012.24-2.24zm-11 0a1.584 1.584 0 11-2.24 2.24 1.584 1.584 0 012.24-2.24z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: "non-scaling-stroke"
  })));
}
export default SvgShipments;